import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ElementRef,
  QueryList,
  ViewChildren,
  AfterViewChecked,
} from '@angular/core';

@Component({
  selector: 'stc-apps--multi-step-loader',
  templateUrl: './multi-step-loader.component.html',
  styleUrls: ['./multi-step-loader.component.scss'],
})
export class MultiStepLoaderComponent
  implements OnChanges, OnDestroy, AfterViewChecked
{
  @Input() loadingStates: { text: string }[] = [];
  @Input() loading = false;
  @Input() duration = 2000;

  currentStep = 0;
  intervalId: any;

  @ViewChildren('stepItem') stepItems!: QueryList<ElementRef>;

  private hasStarted = false;
  private apiFinished = false;

  completed = false;

  // =========================
  // CHANGES
  // =========================
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading']) {
      if (this.loading) {
        this.start();
      } else {
        this.finishLoading();
      }
    }
  }

  // =========================
  // START
  // =========================
  start() {
    if (this.hasStarted || !this.loadingStates.length) return;

    this.hasStarted = true;
    this.apiFinished = false;
    this.completed = false;
    this.currentStep = 0;

    this.clearInterval();

    const stepDuration = this.duration / this.loadingStates.length;

    this.intervalId = setInterval(() => {
      if (this.apiFinished) return;

      // 🔥 STOP at last step (do NOT complete)
      if (this.currentStep < this.loadingStates.length - 1) {
        this.currentStep++;
        this.scrollToActive();
      } else {
        // stay on last step and wait for API
        this.clearInterval(); // optional but cleaner
      }
    }, stepDuration);
  }

  // =========================
  // COMPLETE ALL
  // =========================
  completeAllSteps() {
    this.clearInterval();

    this.completed = true;
    this.currentStep = this.loadingStates.length - 1;

    this.scrollToActive();

    setTimeout(() => {
      this.reset();
    }, 400);
  }

  // =========================
  // FINISH FROM API
  // =========================
  finishLoading() {
    if (this.apiFinished) return;

    this.apiFinished = true;
    this.completeAllSteps();
  }

  // =========================
  // RESET
  // =========================
  reset() {
    this.hasStarted = false;
    this.loading = false;
    this.currentStep = 0;
    this.completed = false;
  }

  // =========================
  // CLEAR
  // =========================
  clearInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  // =========================
  // SCROLL
  // =========================
  scrollToActive() {
    const items = this.stepItems?.toArray();
    if (!items || this.currentStep >= items.length) return;

    items[this.currentStep].nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  ngAfterViewChecked(): void {
    this.scrollToActive();
  }

  ngOnDestroy(): void {
    this.clearInterval();
  }
}
